import React from "react";
import { CALCULATORS, getSelectedCalcData } from "../data/calculatorData";
import { Link } from "gatsby";
import { FaAngleRight } from "react-icons/fa";

/*

* React FC
  
*/

const MoreCalculators = () => {
  return (
    <>
      <h3 className="para-1-bold bold ">More Financial Calculators</h3>
      <div className="shadow-normal rounded moreCalcWrapper">
        {CALCULATORS.map((cal, ind) => {
          const { name } = getSelectedCalcData(cal);
          return (
            <Link
              to={`/calculators/${cal}/`}
              key={ind}
              className="flex space-between otherCalcLink"
            >
              <div className="flex space-between w-100 para-3-bold bold align-center moreCalcLinkContainer" key={ind}>
                {name}
                <FaAngleRight className="arrowIcon" />
              </div>
            </Link>
          );
        })}
        <style jsx> {
          `.moreCalcWrapper{
            box-sizing:border-box;
            margin-bottom:40px;
          }
          .moreCalcLinkContainer{
            border-bottom: 1px solid #ececec;
            padding: 16px;
          }
          .arrowIcon{
            color:#606060;
          }
          .otherCalcLink:hover > .moreCalcLinkContainer {
            color: #4dc3b6;
          }
          .moreCalcLinkContainer:hover {
            background-color: rgba(77, 195, 182, 0.05);
          }
          `
        }</style>
      </div>
    </>
  );
};

export default MoreCalculators;
